module.exports = __webpack_public_path__ + "static/img/wind@2x.430e5fcc.png";